import {Title} from '@priority-software/priority-style-react';
import React from 'react';
import texts from '../../texts';
import {chartConfigInfo} from '../../consts';

const FormInputItem = ({item}) => {
    const labelText = texts[item.key];
    const isMandatory = item.key === chartConfigInfo.chartName;
    return (
        <div style={{width: '100%', padding: '15px 0'}}>
            <Title skin="h6" fontWeight="normal" style={{marginBottom: '8px'}}>
                {labelText}
                {isMandatory && <span style={{color: 'red'}}>*</span>}
            </Title>
            {item.inputComponent}
        </div>
    );
};

export default FormInputItem;
